


































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Alerta} from '@/model/resource/Alerta'
import {AlertaCollection} from '@/model/collection/AlertaCollection'
import {ListAlertaSchema} from '@/schema/resource/Alerta/ListAlertaSchema'
import {CsvAlertaSchema} from '@/schema/resource/Alerta/CsvAlertaSchema'

@Component
export default class ListAlertaView extends Mixins(MixinQueryRouter) {
  schema = new ListAlertaSchema()
  collection = new AlertaCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  goToPersistView(item: Alerta) {
    Helper.pushByName('editAlerta', item.$id)
  }

  async removeItem(item: Alerta) {
    await new DialogRemove(item).confirm(() => item.removeAlerta())
    await this.collection.listAlerta()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AlertaCollection().clearFilters().addFilter(params)

    await csv.listCsvAlerta()
    new CsvAlertaSchema().downloadCsv(csv.all())
  }
}
